import get from 'lodash.get';

import { selectPlan } from '../../../../redux/auth/user/selectors';
import * as billingSelectors from '../../../../redux/auth/billing/selectors';
import { createDeepEqualSelector } from '../../../../redux/utils/selectors';

import * as fmt from '../../../../utils/formatters';

import {
  BILLING_CYCLE_MONTHLY,
  BILLING_CYCLE_YEARLY,
  PRODUCT_ADVANCED_PRICES,
  PRODUCT_PROFESSIONAL_PRICES,
} from '../../../../constants/payment';
import { PLAN_ADVANCED, PLAN_PROFESSIONAL } from '../../../../constants/app';

const calculatePrice = (price, billingCycle) => {
  if (billingCycle === BILLING_CYCLE_YEARLY) {
    return price * 12;
  }

  return price;
};

export const selectDuration = createDeepEqualSelector(
  billingSelectors.selectSubscriptionBillingCycle,
  (billingCycle) => {
    if (billingCycle === BILLING_CYCLE_YEARLY) {
      return 'year';
    }

    if (billingCycle === BILLING_CYCLE_MONTHLY) {
      return 'month';
    }

    return '-';
  },
);

export const selectPrice = createDeepEqualSelector(
  [selectPlan, billingSelectors.selectSubscriptionBillingCycle],
  (plan, billingCycle) => {
    if (plan === PLAN_ADVANCED) {
      const initialPrice = get(PRODUCT_ADVANCED_PRICES, billingCycle, 0);
      const finalPrice = calculatePrice(initialPrice, billingCycle);

      return fmt.currencyUSD(finalPrice);
    }

    if (plan === PLAN_PROFESSIONAL) {
      const initialPrice = get(PRODUCT_PROFESSIONAL_PRICES, billingCycle, 0);
      const finalPrice = calculatePrice(initialPrice, billingCycle);

      return fmt.currencyUSD(finalPrice);
    }

    return fmt.currencyUSD(0);
  },
);

export const selectCurrentPeriodEnd = createDeepEqualSelector(
  [billingSelectors.selectSubscriptionPeriodEnd],
  (currentPeriodEnd) => {
    if (!currentPeriodEnd) {
      return '-';
    }

    return fmt.dateHumanize(currentPeriodEnd);
  },
);
